import Model from './Model';

export default class TrajectoryState extends Model {
    name;
    code;

    static apiPath() {
        return 'trajectory-states';
    }
}



// WEBPACK FOOTER //
// ./src/models/TrajectoryState.js